import React, { PureComponent } from 'react'

import './divider.scss'

class Divider extends PureComponent {
	onRemove = () => {
		const { editor, node } = this.props

		editor.removeNodeByKey(node.key)
	}

	render() {
		const { attributes } = this.props

		return (
			<div
				{...attributes}
				className={`c-divider ${attributes.className}`}
			>
				<hr />
			</div>
		)
	}
}

export default Divider
